import React from "react";
import Footer from "./footer";
import SectionTitle from "./section-title";
import Leaders from "./leaders";
import Promise from "./promise";
import Uniform from "./uniform";

function Scouts() {
  return (
    <div className="scouts" id="scouts">
      <SectionTitle section={"scouts"} />
      <Leaders section={"scouts"} />
      <Promise
        section={"scouts"}
      />
      <Uniform 
        section={"scouts"}
      />
      <Footer />
    </div>
  );
}

export default Scouts;
